import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('awsLambda'),
  hasConnectionStatus: false,
  avatarPath: avatars.awsLambda,
  logoPath: logos.awsLambda
});
